import { Box, Button, Text } from '@bonanza-social/moonlight';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { memo, useCallback } from 'react';
import {
  optOut,
  selectOptOutPending,
} from '../../../state/promos/promos.slice';
import { OptOutPromoBottomSheetProps } from './OptOutPromo.types';

function OptOutPromo({ close, promotionId }: OptOutPromoBottomSheetProps) {
  const isLoading = useSelector(selectOptOutPending(promotionId));
  const dispatch = useDispatch();
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleOnPress = useCallback(async () => {
    const result = await dispatch(optOut(promotionId));

    if (result.meta.requestStatus === 'fulfilled') {
      navigation.goBack();
      close();
    }
  }, [dispatch, promotionId, navigation, close]);

  return (
    <Box gap="space-200">
      <Text variant="h5" color="darkSurfacePrimary">
        Opt out of promotion?
      </Text>
      <Text variant="body-m" color="darkSurfacePrimary">
        By choosing to opt out, you will lose all your progress in this
        promotion. Are you sure you want to proceed?
      </Text>
      <Button
        variant="primary"
        locNS="common"
        locKey="continue"
        width="100%"
        marginTop="space-200"
        loading={isLoading}
        onPress={handleOnPress}
      />
    </Box>
  );
}

export default memo(OptOutPromo);
